import React, { useCallback, useEffect, useState } from 'react';

import { useGBulkStudentTransferList } from 'actions/student-transfer/bulk-student';
import { AppProvider } from 'app-context';
import { Drawer } from 'comps';

import { StudentTransferWrapper } from './styles';
import STOverallInfo from './overall-info';
import TransferInfoTable from './transfer-info';
import { useSelector } from 'react-redux';
import { getCookie } from 'utils';

const StudentTransfer = () => {
  const { auth: { userId: storeUserId } = {} } = useSelector(storeData => storeData);
  const [sidePanelView, setSidePanelView] = useState({});

  const {
    get: getStudentTransferList,
    data,
    isProcessing,
  } = useGBulkStudentTransferList();
  const {
    student_teacher_transfer_details: studentTeacherTransferDetails,
    request_counts: requestCounts,
  } = data || {};
  const userId = storeUserId || getCookie('user_id') || getCookie('emp_id');

  const openDrawer = drawerData => {
    setSidePanelView(drawerData);
  };

  const makeStudentTransferAPICall = useCallback(() => {
    getStudentTransferList(userId, {
      include_students_regular_slot_details: true,
      include_student_course_details: true,
      include_various_request_counts: true,
    });
  }, [getStudentTransferList, userId]);

  useEffect(() => {
    makeStudentTransferAPICall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AppProvider state={{ setSidePanelView, sidePanelView }}>
      <Drawer />
      <StudentTransferWrapper>
        <STOverallInfo requestCounts={requestCounts} />

        <TransferInfoTable
          openDrawer={openDrawer}
          studentTransferAPIData={studentTeacherTransferDetails}
          refetchStudentTransferList={makeStudentTransferAPICall}
          fetchingStudentList={isProcessing}
        />
      </StudentTransferWrapper>
    </AppProvider>
  );
};

export default StudentTransfer;
